"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.matchUTC = exports.asNormalizedDateString = exports.asDate = void 0;
var _constants = require("../../config/constants");
var _date = require("../type-checks/date");
var _number = require("../type-checks/number");
var _string = require("../type-checks/string");
var _leadingCharacters = require("./leadingCharacters");
var matchUTC = exports.matchUTC = /^[0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}:[0-9]{2}(?:\.[0-9]{3,6})?Z$/;
var asNormalizedDateString = exports.asNormalizedDateString = function asNormalizedDateString(input) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref$delineators = _ref.delineators,
    delineators = _ref$delineators === void 0 ? "/.,-" : _ref$delineators,
    _ref$separator = _ref.separator,
    separator = _ref$separator === void 0 ? "/" : _ref$separator;
  // Let return value be input;
  var returnValue = input;
  // If input is string of length and is not UTC;
  if ((0, _string.isStringOfLength)(input) && !matchUTC.test(input)) {
    // Create regular expression to use in split;
    var regExp = new RegExp("(\\d+)[" + delineators + "]");
    // Let input parts be a filtered array of strings split by the expected delineators regex;
    var inputParts = input.split(regExp).filter(function (part) {
      return (0, _string.isStringOfLength)(part);
    });
    // Let normalized input array be empty;
    var normalizedInput = [];
    // Iterate over input parts;
    inputParts.forEach(function (part) {
      // Push part to normalized input array with leading characters;
      normalizedInput.push((0, _leadingCharacters.leadingCharacters)(part));
    });
    // Set return value to normalized input array joined by separator;
    returnValue = normalizedInput.join(separator);
  }
  // Return;
  return returnValue;
};
var asDate = exports.asDate = function asDate(input) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref2$outputPattern = _ref2.outputPattern,
    outputPattern = _ref2$outputPattern === void 0 ? "mm/dd/yyyy" : _ref2$outputPattern;
  // Nullify date input to start;
  var dateInput = null;
  // If input is string, number, or date object, set it as dateInput;
  if ((0, _string.isStringOfLength)(input)) {
    dateInput = new Date(asNormalizedDateString(input));
  } else if ((0, _number.isNumber)(input) && input > 0) {
    dateInput = new Date(input);
  } else if ((0, _date.isDate)(input)) {
    dateInput = input;
  }
  // If a dateInput date object is set;
  if ((0, _date.isDate)(dateInput)) {
    var separator = "/";
    // Set flags for short date, month, year;
    var isShortDate = false;
    var isShortMonth = false;
    var isShortYear = false;
    // Set null placeholders for date, month, year;
    var date = null;
    var month = null;
    var year = null;
    // Define method to get date string;
    var getFormattedDateStringsObj = function getFormattedDateStringsObj(isText) {
      // Set formatted date, month, year, from dateInput;
      var formattedDate = dateInput.getDate();
      var formattedMonth = dateInput.getMonth();
      var formattedYear = dateInput.getFullYear().toString();
      // If date string is to be formatted as text;
      if (isText) {
        // Set formatted month from array of months;
        formattedMonth = _constants.MONTHS[formattedMonth][isShortMonth ? "short" : "long"];
      } else {
        // Set formatted month to value, rather than index;
        formattedMonth = formattedMonth + 1;
        // If not short month, pad the month with leading zero;
        !isShortMonth && (formattedMonth = (0, _leadingCharacters.leadingCharacters)(formattedMonth));
      }
      // If not short date, pad the date with leading zero;
      !isShortDate && (formattedDate = (0, _leadingCharacters.leadingCharacters)(formattedDate));
      // If short year, substring formatted year;
      isShortYear && (formattedYear = formattedYear.substring(2));
      // Return object of date, month, year;
      return {
        date: formattedDate,
        month: formattedMonth,
        year: formattedYear
      };
    };
    switch (outputPattern) {
      case "m/d/yy":
      case "m.d.yy":
        // Define separator as needed;
        separator = outputPattern === "m.d.yy" ? "." : separator;
        // Set short date, month, and year flags;
        isShortDate = isShortMonth = isShortYear = true;
        // Call method to get date string, destructuring;
        // Set dateInput to formatted string;
        var _getFormattedDateStri = getFormattedDateStringsObj();
        date = _getFormattedDateStri.date;
        month = _getFormattedDateStri.month;
        year = _getFormattedDateStri.year;
        dateInput = month + separator + date + separator + year;
        break;
      case "mm/dd/yy":
        isShortYear = true;
        // Call method to get date string, destructuring;
        // Set dateInput to formatted string;
        var _getFormattedDateStri2 = getFormattedDateStringsObj();
        date = _getFormattedDateStri2.date;
        month = _getFormattedDateStri2.month;
        year = _getFormattedDateStri2.year;
        dateInput = month + separator + date + separator + year;
        break;
      case "mm/dd/yyyy":
        // Call method to get date string, destructuring;
        // Set dateInput to formatted string;
        var _getFormattedDateStri3 = getFormattedDateStringsObj();
        date = _getFormattedDateStri3.date;
        month = _getFormattedDateStri3.month;
        year = _getFormattedDateStri3.year;
        dateInput = month + separator + date + separator + year;
        break;
      case "yyyy/mm/dd":
      case "yyyy/mm":
        // Call method to get date string, destructuring;
        // Set dateInput to formatted string;
        var _getFormattedDateStri4 = getFormattedDateStringsObj();
        date = _getFormattedDateStri4.date;
        month = _getFormattedDateStri4.month;
        year = _getFormattedDateStri4.year;
        dateInput = year + separator + month + (outputPattern === "yyyy/mm/dd" ? separator + date : "");
        break;
      case "yyyy-mm":
      case "yyyy-mm-dd":
        // Define separator as needed;
        separator = "-";
        // Call method to get date string, destructuring;
        // Set dateInput to formatted string;
        var _getFormattedDateStri5 = getFormattedDateStringsObj();
        date = _getFormattedDateStri5.date;
        month = _getFormattedDateStri5.month;
        year = _getFormattedDateStri5.year;
        dateInput = year + separator + month + (outputPattern === "yyyy-mm-dd" ? separator + date : "");
        break;
      case "mm dd, yyyy":
        // Call method to get date string, destructuring;
        // Set dateInput to formatted string;
        var _getFormattedDateStri6 = getFormattedDateStringsObj(true);
        date = _getFormattedDateStri6.date;
        month = _getFormattedDateStri6.month;
        year = _getFormattedDateStri6.year;
        dateInput = month + " " + date + ", " + year;
        break;
      case "m d, yyyy":
        // Set short date and month flags;
        isShortDate = isShortMonth = true;
        // Call method to get date string, destructuring;
        // Set dateInput to formatted string;
        var _getFormattedDateStri7 = getFormattedDateStringsObj(true);
        date = _getFormattedDateStri7.date;
        month = _getFormattedDateStri7.month;
        year = _getFormattedDateStri7.year;
        dateInput = month + " " + date + ", " + year;
        break;
      case "m d, yy":
        // Set short date, month, and year flags;
        isShortDate = isShortMonth = isShortYear = true;
        // Call method to get date string, destructuring;
        // Set dateInput to formatted string;
        var _getFormattedDateStri8 = getFormattedDateStringsObj(true);
        date = _getFormattedDateStri8.date;
        month = _getFormattedDateStri8.month;
        year = _getFormattedDateStri8.year;
        dateInput = month + " " + date + ", " + year;
        break;
      case "d":
      case "dd":
        // Set short flag;
        isShortDate = outputPattern === "d";
        // Call method to get date string, destructuring;
        // Set dateInput to formatted string;
        var _getFormattedDateStri9 = getFormattedDateStringsObj(true);
        date = _getFormattedDateStri9.date;
        dateInput = date.toString();
        break;
      case "m":
      case "mm":
        // Set short flag;
        isShortMonth = outputPattern === "m";
        // Call method to get date string, destructuring;
        // Set dateInput to formatted string;
        var _getFormattedDateStri10 = getFormattedDateStringsObj(true);
        month = _getFormattedDateStri10.month;
        dateInput = month.toString();
        break;
      case "yy":
      case "yyyy":
        // Set short flag;
        isShortYear = outputPattern === "yy";
        // Call method to get date string, destructuring;
        // Set dateInput to formatted string;
        var _getFormattedDateStri11 = getFormattedDateStringsObj(true);
        year = _getFormattedDateStri11.year;
        dateInput = year.toString();
        break;
      default:
        // Set dateInput to input;
        dateInput = input;
    }
    return dateInput;
  }
  return input;
};